// captureTypeIcon — CAP-A (VISUAL-AUDIT 2026-08-11).
//
// The Capture empty state hard-coded the Note glyph (StickyNote2Outlined) for
// EVERY empty category, so switching to the Video / Audio / Document / Link
// filter with zero items showed a note icon — only the Note filter's empty state
// happened to be right. The empty-state COPY was already per-type
// (captureEmptyState); the ICON was not.
//
// Fix: pick the empty-state art from the SELECTED type, reusing the SAME per-type
// line-art glyphs the composer type-tabs already use (AddCaptureModal
// COMPOSER_TABS) — one glyph per role, everywhere (G-75 icon-role consistency),
// line-art (MUI outlined), never emoji. Photo/Video/Audio/Document/Link map to
// their composer glyphs; TEXT and the whole-inbox / unknown case keep the note
// art the empty panel has always shown.

import StickyNote2OutlinedIcon from "@mui/icons-material/StickyNote2Outlined";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";
import MicOutlinedIcon from "@mui/icons-material/MicOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import LinkRoundedIcon from "@mui/icons-material/LinkRounded";
import { CAPTURE_TYPES } from "./Capture.helpers";

// Note art for TEXT and for the whole-inbox / unknown fallback. The mic-for-audio
// choice mirrors QA-93; the rest mirror AddCaptureModal's COMPOSER_TABS icons.
export const CAPTURE_TYPE_EMPTY_ICON = {
  [CAPTURE_TYPES.TEXT]: StickyNote2OutlinedIcon,
  [CAPTURE_TYPES.PHOTO]: ImageOutlinedIcon,
  [CAPTURE_TYPES.VIDEO]: VideocamOutlinedIcon,
  [CAPTURE_TYPES.AUDIO]: MicOutlinedIcon,
  [CAPTURE_TYPES.DOC]: DescriptionOutlinedIcon,
  [CAPTURE_TYPES.LINK]: LinkRoundedIcon,
};

// The empty-state art (a React icon component) for a capture type. Falls back to
// the note glyph for the whole-inbox state (FILTER_ALL) and any unknown value.
export function captureEmptyStateIcon(type) {
  return CAPTURE_TYPE_EMPTY_ICON[type] || StickyNote2OutlinedIcon;
}
